import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function CustomerPage() {
  const customer = useSelector((store) => store.customer);
  const [customerData, setCustomerData] = useState(null);
  const navigate = useNavigate();

  try {
    const getCustomer = async () => {
      const response = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + `/api/customers/${customer.id}`,
        headers: { Authorization: `Bearer ${customer.access_token}` },
      });
      response && setCustomerData(response.data);
      console.log(response.data);
    };

    useEffect(() => {
      getCustomer();
    }, []);
  } catch (error) {
    console.log("Error: ", error);
  }

  return (
    customerData && (
      <div className="container my-5 pt-5 animate__animated animate__fadeIn">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <h1 className="h2 text-start mt-5">Profile</h1>
            <ul className="list-group mt-4">
              <li className="list-group-item">
                Firstname: {customerData.firstname}
              </li>
              <li className="list-group-item">
                Lastname: {customerData.lastname}
              </li>
              <li className="list-group-item">E-mail: {customerData.email}</li>
              <li className="list-group-item">
                Phone number: {customerData.phoneNumber}
              </li>
              <li className="list-group-item">
                Address: {customerData.address}
              </li>
            </ul>
            <div className="d-flex justify-content-end">
              <button
                className="btn w-100 btn-submit btn-yellow px-3 text-uppercase rounded my-4"
                id="submitButton"
                onClick={() => {
                  navigate(
                    `/customers/${customer.firstname.toLowerCase()}/settings`
                  );
                }}
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default CustomerPage;
